<template>
  <div style="width: 100%; height: 100%">
    <div class="headerBox">
      <div class="imgBox">
        <img alt="icon" :src="logo" />
      </div>
      <div class="info">
        <div class="userInfo">
          <span>
            {{ $t('index_message2') }} , {{ $store.state.companyName }}
          </span>
          <span class="username">
            {{ $store.state.username }}
          </span>
          <el-dropdown
            style="display: flex; align-items: center"
            @command="handleCommand"
          >
            <img src="./image/avatar.png" alt="头像" style="cursor: pointer" />
            <el-dropdown-menu slot="dropdown">
              <div class="dropdown-actions">
                <el-dropdown-item command="password">
                  {{ $t('index_message3') }}
                </el-dropdown-item>
                <el-dropdown-item command="logout">
                  {{ $t('index_message4') }}
                </el-dropdown-item>
              </div>
              <el-dropdown-item divided disabled v-if="hasMultipleAccounts">
                <div style="font-weight: bold; color: #909399">
                  {{ $t('account_switch_title') }}
                </div>
              </el-dropdown-item>
              <el-dropdown-item
                v-for="account in otherAccounts"
                :key="account.index"
                :command="{ type: 'switch', index: account.index }"
              >
                <div class="account-switch-item">
                  <span class="account-email">{{ account.userName }}</span>
                  <span class="account-separator">-</span>
                  <span class="account-name">{{ account.name }}</span>
                </div>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <LanguageButton style="margin-left: 20px" />
        </div>
      </div>
      <!--  修改密码弹窗  -->
      <el-dialog
        title="修改密码"
        width="500px"
        append-to-body
        :visible.sync="dialog"
        :close-on-click-modal="false"
        @close="handleDialogClose"
      >
        <div class="form-wrapper">
          <el-form
            ref="form"
            :model="form"
            :rules="rules"
            size="small"
            label-width="100px"
          >
            <el-form-item label="旧密码" prop="oldPassword">
              <el-input type="password" v-model="form.oldPassword" />
            </el-form-item>
            <el-form-item label="新密码" prop="newPassword">
              <el-input type="password" v-model="form.newPassword" />
            </el-form-item>
            <el-form-item label="确认新密码" prop="repeatPassword">
              <el-input type="password" v-model="form.repeatPassword" />
            </el-form-item>
            <el-form-item label="验证码" prop="verifyCode">
              <el-input v-model="form.verifyCode" />
              <img
                class="verifyCodeBox"
                :src="verify_code_url"
                alt="verifyCode"
                @click="_getVerifyCode"
              />
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer">
          <el-button @click="dialog = false" size="small">取 消</el-button>
          <el-button type="primary" size="small" @click="handleChangePassword">
            确 定
          </el-button>
        </span>
      </el-dialog>
    </div>
    <el-container class="homeBox">
      <el-aside style="width: 208px">
        <el-menu
          default-active="1"
          class="el-menu-vertical-demo"
          background-color="#001529"
          text-color="#fff"
          active-text-color="#409eff"
        >
          <router-link to="home-main">
            <el-menu-item index="1">
              <template slot="title">
                <i class="m-icon icon iconfont icon-shouye"></i>
                <span>{{ $t('index_menu1') }}</span>
              </template>
            </el-menu-item>
          </router-link>
          <router-link to="/my-account">
            <el-menu-item index="2">
              <template slot="title">
                <i class="m-icon icon iconfont icon-wodezhanghu"></i>
                <span>{{ $t('index_menu2') }}</span>
              </template>
            </el-menu-item>
          </router-link>
          <router-link to="/exchange-service">
            <el-menu-item index="3">
              <template slot="title">
                <i
                  class="m-icon icon iconfont icon-chukoutuishui_huanhuichengben"
                ></i>
                <span>{{ $t('index_menu3') }}</span>
              </template>
            </el-menu-item>
          </router-link>
          <router-link to="/withdraw">
            <el-menu-item index="4">
              <template slot="title">
                <i class="m-icon icon iconfont icon-fukuan"></i>
                <span>{{ $t('index_menu4') }}</span>
              </template>
            </el-menu-item>
          </router-link>
          <router-link to="/currency-holiday">
            <el-menu-item index="5">
              <template slot="title">
                <i class="m-icon icon iconfont icon-wancheng"></i>
                <span>{{ $t('index_menu5') }}</span>
              </template>
            </el-menu-item>
          </router-link>
          <!--          <router-link to="/funds-inflow">
            <el-menu-item index="7">
              <template slot="title">
                <i class="m-icon icon iconfont icon-wancheng"></i>
                <span>{{ $t('index_menu7') }}</span>
              </template>
            </el-menu-item>
          </router-link>-->
          <router-link to="/system-settings">
            <el-menu-item index="6">
              <template slot="title">
                <i class="m-icon icon iconfont icon-jinggao_o"></i>
                <span>{{ $t('index_menu6') }}</span>
              </template>
            </el-menu-item>
          </router-link>
        </el-menu>
      </el-aside>
      <div style="width: calc(100% - 208px)">
        <router-view />
      </div>
    </el-container>
  </div>
</template>

<script>
import { logout, modifyPassword, getVerifyCode } from './api';
import logo from '@/static/images/main-logo.png';
import LanguageButton from '@/components/LanguageButton.vue';
import accountManager from '@/utils/account-manager';
import request from '@/utils/request';
import { mapMutations } from 'vuex';

export default {
  name: 'my-header',
  data() {
    return {
      logo,
      verify_code_url: '',
      dialog: false,
      form: {
        oldPassword: '',
        newPassword: '',
        repeatPassword: '',
        verifyCode: '',
      },
      hasMultipleAccounts: false,
      otherAccounts: [],
    };
  },
  mounted() {
    this.loadAccountInfo();
  },
  computed: {
    rules() {
      const validatePass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error(this.$t('register_form4_placeholder')));
        } else {
          if (this.form.repeatPassword !== '') {
            this.$refs.form.validateField('repeatPassword');
          }
          callback();
        }
      };
      const validatePass2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error(this.$t('register_form5_placeholder')));
        } else if (value !== this.form.newPassword) {
          callback(new Error(this.$t('register_form5_validate')));
        } else {
          callback();
        }
      };
      return {
        oldPassword: [
          { required: true, message: this.$t('COMMON_ERR1'), trigger: 'blur' },
        ],
        newPassword: [
          { required: true, validator: validatePass, trigger: 'blur' },
        ],
        repeatPassword: [
          { required: true, validator: validatePass2, trigger: 'blur' },
        ],
        verifyCode: [{ required: true, trigger: 'blur' }],
      };
    },
  },
  methods: {
    ...mapMutations(['setMenus', 'setToken', 'setCompanyName']),

    // 加载账户信息
    loadAccountInfo() {
      this.hasMultipleAccounts = accountManager.hasMultipleAccounts();

      if (this.hasMultipleAccounts) {
        const allAccounts = accountManager.getAccountDisplayList();
        const currentIndex = accountManager.getCurrentAccountIndex();

        // 过滤掉当前账户，只显示其他账户
        this.otherAccounts = allAccounts.filter(
          account => account.index !== currentIndex,
        );
      }
    },

    handleDialogClose() {
      this.$refs.form.resetFields();
    },
    handleCommand(command) {
      // 处理账户切换
      if (typeof command === 'object' && command.type === 'switch') {
        this.handleSwitchAccount(command.index);
        return;
      }

      // 原有的命令处理
      if (command === 'logout') {
        try {
          this.handleLogout();
        } catch (err) {
          console.error(err);
        }
      } else if (command === 'password') {
        this.dialog = true;
        this._getVerifyCode();
      }
    },

    // 切换账户
    async handleSwitchAccount(accountIndex) {
      try {
        const account = accountManager.switchAccount(accountIndex);

        if (account) {
          // 更新 Vuex 状态
          this.setToken(account.token);
          this.setMenus(account.menu);
          this.setCompanyName(account.name);

          this.$message.success(
            `${this.$t('account_switch_success')}: ${account.name}`,
          );

          // 刷新页面
          setTimeout(() => {
            this.$router.go(0);
          }, 500);
        } else {
          this.$message.error(this.$t('account_switch_failed'));
        }
      } catch (error) {
        console.error('切换账户失败:', error);
        this.$message.error(this.$t('account_switch_failed'));
      }
    },

    async _getVerifyCode() {
      this.verify_code_url = await getVerifyCode({});
    },
    async handleChangePassword() {
      try {
        const valid = await this.$refs.form.validate();
        if (valid) {
          const { oldPassword, newPassword, verifyCode } = this.form;
          await modifyPassword({ oldPassword, newPassword, code: verifyCode });
          this.$message.success(this.$t('index_message'));
          this.dialog = false;
          await this._logout();
        }
      } catch (err) {
        console.error(err);
      }
    },
    async handleLogout() {
      try {
        await logout();
        const storage = this.$storage;
        const items = [
          'allAccounts',
          'hasMultipleAccounts',
          'currentAccountIndex',
        ];

        items.forEach(item => {
          // 某些插件可能支持 .has() 方法，如果没有则用 getItem 判断
          if (storage.getItem(item)) {
            storage.clearItem(item);
          }
        });
        this.$message.success(this.$t('exit_success'));
        await this._logout();
      } catch (err) {
        console.error(err);
      }
    },
    async _logout() {
      // 清除账户信息
      accountManager.clearAllAccounts();
      this.$store.commit('clearAllStore');
      await this.$router.push('/user/login');
    },
  },
  components: {
    LanguageButton,
  },
};
</script>

<style scoped lang="scss">
.verifyCodeBox {
  width: 104px;
  height: 37px;
  margin-top: 10px;
  cursor: pointer;
}
.headerBox {
  box-sizing: border-box;
  padding: 0 43px;
  display: flex;
  justify-content: space-between;
  width: 100%;
  height: 48px;
  line-height: 48px;
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.1);
  .imgBox {
    width: 126px;
    height: 74%;
    img {
      height: 100%;
    }
  }
  .info {
    display: flex;
    align-items: center;
    .userInfo {
      display: flex;
      .username {
        margin-right: 10px;
      }
    }
  }
  .title {
    color: #147fd2;
    font-size: 28px;
    font-weight: bold;
  }
  .isActive {
    color: #147fd2;
  }
  .btnArea {
    display: flex;
    align-items: center;
    font-size: 16px;
    margin-bottom: 0;
    span {
      cursor: pointer;
      font-weight: bold;
    }
    span:nth-child(2) {
      font-size: 14px;
      margin-left: 20px;
    }
  }
}

/* 账户切换样式 */
.dropdown-actions {
  display: flex;
  gap: 0;
}

.account-switch-item {
  display: flex;
  align-items: center;
  gap: 8px;
  white-space: nowrap;

  .account-email {
    font-size: 13px;
    color: #606266;
  }

  .account-separator {
    color: #dcdfe6;
    font-size: 12px;
  }

  .account-name {
    font-size: 13px;
    color: #303133;
  }
}

::v-deep .el-dropdown-menu__item {
  &.is-disabled {
    cursor: default;
    color: #909399;

    &:hover {
      background-color: transparent;
    }
  }
}

.homeBox {
  width: 100%;
  min-height: calc(100% - 48px);
  .el-submenu {
    i {
      margin-right: 10px;
    }
  }
  .m-icon {
    margin-right: 8px;
  }
}
::v-deep .el-aside {
  overflow: hidden;
}
::v-deep .el-menu {
  height: 100%;
}
</style>
